import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d88dcae")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")

  return (_openBlock(), _createBlock(_component_ion_button, {
    size: "small",
    class: { lg: _ctx.isLarge }
  }, {
    default: _withId(() => [
      (_ctx.checkmark)
        ? (_openBlock(), _createBlock(_component_ion_icon, {
            key: 0,
            slot: "start",
            icon: "/assets/icons/checkmark.svg"
          }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.text), 1 /* TEXT */)
    ]),
    _: 1
  }, 8, ["class"]))
})